import { useEffect, useState } from "react";

// Shopify's "Buy with Shop Pay" web component (the same one Hydrogen's ShopPayButton renders).
// It sends the shopper straight to Shopify checkout with this variant and quantity.
const SHOP_JS_URL = "https://cdn.shopify.com/shopifycloud/shop-js/v1.0/client.js";
const STORE_DOMAIN = process.env.REACT_APP_SHOPIFY_DOMAIN;

let scriptPromise = null;
function loadShopJs() {
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = SHOP_JS_URL;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
}

// "gid://shopify/ProductVariant/123" -> "123"
export function numericVariantId(id) {
  const n = String(id || "").split("/").pop();
  return /^\d+$/.test(n) ? n : null;
}

export default function ShopPayButton({ variantId, quantity = 1 }) {
  const [ready, setReady] = useState(false);
  const id = numericVariantId(variantId);

  useEffect(() => {
    if (!id || !STORE_DOMAIN) return;
    let alive = true;
    loadShopJs().then(() => alive && setReady(true)).catch(() => {});
    return () => {
      alive = false;
    };
  }, [id]);

  if (!id || !STORE_DOMAIN) return null;
  return (
    <div data-testid="shop-pay-button" className="mt-3 min-h-[48px]" style={{ "--shop-pay-button-width": "100%" }}>
      {ready && <shop-pay-button store-url={`https://${STORE_DOMAIN}`} variants={`${id}:${Math.max(1, quantity)}`} channel="headless" />}
    </div>
  );
}
